// extracted by mini-css-extract-plugin
export default {"sigPad":"InformedConsent_sigPad__CAzgx"};